<template>
  <div>
    <div v-if="data !== null" class="converstions-show-code">
      <div class="overlay"></div>
      <div class="converstions-show-code-content">
        <h3 class="converstions-popup-title">Event Code</h3>
        <h5 class="converstions-popup-sub-title">Embed Code</h5>
        <p class="embed-code-desc">Attach the event code below to the relevant HTML <br> element where the user will
          click.</p>
        <div class="first-code-actions-parent conversions-popup-actions">
          <vx-tooltip text="Copy" position="top">
            <vs-icon @click="copyMainCode()" class="conversions-copy" icon="speakol-copy" icon-pack="speakol">
            </vs-icon>
          </vx-tooltip>

          <vx-tooltip text="Download" position="top">
            <vs-icon @click="saveMainCodeAsText()" class="conversions-download" icon="speakol-download"
              icon-pack="speakol"></vs-icon>
          </vx-tooltip>
        </div>
        <div class="code-area">
          <p>{{ data.code }}</p>
        </div>
        <input id="myInput" class="hidden-input" :value="data.code" type="text">

        <h5 class="converstions-popup-sub-title postback-desc">Postback Documentation or Mobile Apps Tracking</h5>
        <!-- <p class="embed-code-desc">Click to know more about adding <a href="">Postback </a>and <a href="">mobile apps
            tracking.</a></p> -->
        <div class="second-code-actions-parent conversions-popup-actions">
          <vx-tooltip text="Copy" position="top">
            <vs-icon @click="copyPostbackCode()" class="conversions-copy" icon="speakol-copy" icon-pack="speakol">
            </vs-icon>
          </vx-tooltip>

          <vx-tooltip text="Download" position="top">
            <vs-icon @click="downloadPostbackCode()" class="conversions-download" icon="speakol-download" icon-pack="speakol"></vs-icon>
          </vx-tooltip>
        </div>

        <div class="code-area">
          <p>{{ data.url }}</p>
        </div>
        <input id="myInput2" class="hidden-input" :value="data.url" type="text">

        <div class="conversions-popup-close">
          <button @click="closePixelCode()">Close</button>
        </div>
      </div>
    </div>

    <SpeakolNotificationToaster :show="toaster.show" :message="toaster.message" :icon="toaster.icon"
      :closeButtonText="toaster.closeButtonText">
      <template v-slot:close>
        <vs-icon @click="toaster.show=false" class="x-icon" color="#FFFFFF" icon="speakol-cancel" icon-pack="speakol">
        </vs-icon>
      </template>
    </SpeakolNotificationToaster>
  </div>
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'

export default {
  components: {
    SpeakolNotificationToaster
  },
  data () {
    return {
      data: null,
      toaster: {
        show: false,
        message: '',
        icon: require('@/assets/images/success.svg'),
        closeButtonText: 'close'
      }
    }
  },
  mounted () {
    this.$root.$on('view-pixel-code-clicked', (data) => {
      this.data = data
    })
  },
  methods: {
    closePixelCode () {
      this.data = null
    },
    copyMainCode () {
      const copyText = document.getElementById('myInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.toaster.show = true
      this.toaster.message = 'The Embed Code has been copied to the clipboard.'
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    },
    copyPostbackCode () {
      const copyText = document.getElementById('myInput2')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.toaster.show = true
      this.toaster.message = 'The Postback Code has been copied to the clipboard.'
      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    },
    saveMainCodeAsText () {
      this.saveTextAsFile(this.data.code, 'installation_code.txt')
    },
    downloadPostbackCode () {
      this.saveTextAsFile(this.data.url, 'postback_code.txt')
    },
    saveTextAsFile (textToWrite, fileNameToSaveAs) {
      const textFileAsBlob = new Blob([textToWrite], {
        type: 'text/plain'
      })
      const downloadLink = document.createElement('a')
      downloadLink.download = fileNameToSaveAs
      downloadLink.innerHTML = 'Download File'
      if (window.webkitURL !== null) {
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob)
      } else {
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
      }
      downloadLink.click()
    }
  }
}

</script>

<style lang="scss" scoped>
  .converstions-show-code {
    .overlay {
      z-index: 99991 !important;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.27);
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .converstions-show-code-content {
      z-index: 99991 !important;
      position: fixed;
      width: 730px;
      padding: 48px;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: #fff;
      box-shadow: 0 4px 30px rgba(91, 111, 121, 0.25);
      border-radius: 20px;

      .converstions-popup-title {
        font-weight: 500;
        margin-bottom: 32px;
        font-size: 24px;
        color: #2c2c2c;
      }

      .converstions-popup-sub-title {
        font-weight: 500;
        font-size: 18px;
        color: #2c2c2c;
        margin-bottom: 10px;
      }

      .postback-desc {
        margin-top: 48px;
        float: left;
      }

      .embed-code-desc {
        font-weight: 300;
        font-size: 14px;
        color: #999;
        margin-bottom: 24px;
        float: left;
      }

      .conversions-popup-actions {
        float: right;
        display: flex;
        margin-bottom: 16px;
      }

      .second-code-actions-parent {
        margin-top: 38px;
      }

      .conversions-download {
        color: #0092d7;
        background: rgba(0, 146, 215, 0.16551);
        padding: 10px;
        font-size: 20px !important;
        border-radius: 100%;
        cursor: pointer;

        i {
          display: none;
        }
      }

      .conversions-copy {
        color: #0092d7;
        padding: 10px;
        font-size: 20px !important;
        background: rgba(0, 146, 215, 0.16551);
        border-radius: 100%;
        cursor: pointer;
        margin-right: 16px;
      }

      .code-area {
        border: 1px solid #c2c2c2;
        padding: 20px;
        width: 100%;
        border-radius: 8px;
        display: flex;

        p {
          color: #575757;
        }
      }

      .conversions-popup-close {
        margin-top: 32px;
        text-align: right;

        button {
          background: #0092d7;
          border-radius: 3px;
          color: white;
          font-weight: 500;
          font-size: 14px;
          padding: 16px 75px;
          outline: none;
          box-shadow: none;
          border: none;
          cursor: pointer;
        }
      }
    }

    .hidden-input {
      position: absolute;
      opacity: 0;
    }

    .first-code-actions-parent {
      position: relative;
      top: 11px;
    }
  }

  .x-icon {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .converstions-show-code-content {
      width: 90% !important;
      padding: 24px !important;

      h3 {
        font-size: 18px !important;
        position: relative;
        top: 10px;
      }

      .conversions-popup-close {
        button {
          width: 100%;
        }
      }

      .code-area {
        width: 100%;
        overflow-x: auto;
      }
    }

    .second-code-actions-parent {
      margin-top: 0 !important;
    }

    .first-code-actions-parent {
      position: relative;
      top: 0 !important;
    }
  }

</style>
